import { withStylePrefix } from '../common/withStylePrefix';
import { ContextualActionsComponent, contextualActionsTemplate } from './ContextualActions';
import styles from './ContextualActions.styles.scss';
const contextualActionsDefinition = {
    baseName: 'contextual-actions',
    template: contextualActionsTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonContextualActions = ContextualActionsComponent.compose(contextualActionsDefinition);
